import { Stack, Typography, useMediaQuery } from '@mui/material';
import Grid2 from '@mui/material/Unstable_Grid2/Grid2';
import React, { FC } from 'react';
import { APIS } from '../../../../lib/constants/apis';
import Schema from '../../../../lib/paths/organisation_FULL_Paths.json';
import ApplicationHeading from '../../../../pages/private/online-antrag/application-heading/ApplicationHeading';
import CreateForm from '../../../ui-component/form-component/create-form/CreateForm';
import MUIAlert from '../../../ui-component/mui-alert/MUIAlert';
const P = Schema.attributes;

const OrganisationDaten: FC<{
	formValue: any;
	updateFunction: (_key: string, _value: any) => void;
	organisationDatenError: any;
	formErrorMessage: string;
}> = ({ formValue, updateFunction, organisationDatenError, formErrorMessage }) => {
	const isSmallScreen = useMediaQuery('(max-width:600px)');

	return (
		<>
			<ApplicationHeading title='Organisationsprofil' description='' />
			<Stack spacing={2} mb={2}>
				<Typography variant='body1'>Bitte geben Sie hier die ersten Informationen zu Ihrer Organisation an.</Typography>
				<Typography variant='body1'>
					Die Stammdaten aus Ihrem Profil werden bei der Erstellung eines Antrags immer automatisch übernommen. Bitte gehen Sie daher nach
					erfolgter Registrierung erneut in Ihr Organisationsprofil und vervollständigen Sie dort die Angaben.
				</Typography>
			</Stack>
			{formErrorMessage && (
				<MUIAlert
					infoType='error'
					message='Ihre Organisation ist bereit registriert. Fragen Sie Ihren Nutzerverwalter für die Freischaltung des Accounts'
				/>
			)}

			<Grid2>
				<Grid2 sm={12}>
					<CreateForm
						formValues={formValue}
						formStruc={formStrucSpalte1(isSmallScreen)}
						updateFormValuesFunc={updateFunction}
						formErrors={organisationDatenError}
						api={APIS.Organisation}
					/>
				</Grid2>
			</Grid2>
			<Grid2>
				<Grid2 sm={12}>
					<CreateForm
						formValues={formValue}
						formStruc={formStrucSpalte2()}
						updateFormValuesFunc={updateFunction}
						formErrors={organisationDatenError}
						api={APIS.Organisation}
					/>
				</Grid2>
			</Grid2>
		</>
	);
};

export default OrganisationDaten;

const formStrucSpalte1 = (isSmallScreen: boolean) => {
	return [
		{
			fields: [
				{
					...P.Geschaeftsbezogene_Daten_Name_Der_Organisation,
					tooltip:
						'Bitte geben Sie den vollständigen rechtsverbindlichen Namen Ihrer Organisation inklusive Rechtsform an (z. B. GmbH, UG (haftungsbeschränkt), AG, e. V.), wie im Handels- oder Vereinsregister eingetragen.',
				},
				P.Geschaeftsbezogene_Daten_Rechtsform_Der_Organisation,
			],
			userProps: { direction: 'column', columnToDivide: 1 },
		},
		{
			fields: [P.Unternehmensprofil_Steuernummer, P.Unternehmensprofil_U_St_Id_Nr],
			userProps: { columnToDivide: 2 },
		},
		{
			fields: [P.Adressdaten_Strasse_Und_Hausnummer],
			userProps: { direction: 'column', columnToDivide: 1 },
		},
		{
			fields: [P.Adressdaten_PLZ, P.Adressdaten_Ort],
			userProps: {
				direction: isSmallScreen ? 'column' : 'row',
				columnToDivide: isSmallScreen ? 1 : 2,
				columnGap: '1rem',
			},
		},
	];
};

const formStrucSpalte2 = () => {
	return [
		{
			fields: [
				{ ...P.Kontaktdaten_E_Mail, tooltip: 'Bitte geben Sie hier die zentrale E-Mail-Adresse Ihrer Organisation an.' },
				{
					...P.Kontaktdaten_Telefon,
					tooltip: 'Bitte geben Sie eine zentrale Telefonnummer für Ihre Organisation an. Es sind nur Zahlen und Leerzeichen erlaubt.',
				},
			],
			userProps: { direction: 'column', columnToDivide: 1 },
		},
	];
};
